import clsx from "clsx";
import { IconText } from "components/IconText";
import { GlobalContext } from "contexts/GlobalContext";
import { useContext, useState } from "react";

export const RewriteStorySaveButton = (props: {
    code: string;
    promptText?: string;
    onSaved: () => void;
    isSaved: boolean;
}) => {
    const { code, promptText, onSaved, isSaved } = props;

    const { gameplayService, catchServerError, addNotification } = useContext(GlobalContext);
    const { submitRevisedStory } = gameplayService;

    const [isSubmitting, setIsSubmitting] = useState(false);

    const save = () => {
        setIsSubmitting(true);

        if (promptText) {
            submitRevisedStory({ code, body: promptText })
                .then(x => {
                    if (x.success) {
                        addNotification({ type: "success", title: "Your revision was saved" });
                        onSaved();
                    }

                    setIsSubmitting(false);
                })
                .catch(catchServerError);
        }
    };

    return (
        <button
            type="button"
            className="btn btn-primary icon-link"
            disabled={!promptText || isSubmitting}
            onClick={save}
        >
            <IconText
                icon={clsx("fas", isSubmitting ? "fa-cog fa-spin" : "fa-save")}
                text={isSubmitting ? "Saving" : isSaved ? "Update" : "Save"}
            />
        </button>
    );
};
